import React, { useState } from "react";
import SvgIcon from "./SvgIcon";
import PropTypes from "prop-types";

const PrimaryDropdown = ({
  summaryText,
  options,
  onSelectFn,
  alignRight,
  isAdminConsole = false,
}) => {
  const [opened, setOpened] = useState(false);

  /**
   * Open or close the ul when the user clicks the button
   * @param {*} e
   */
  const handleClick = (e) => {
    e.preventDefault();
    setOpened(true);
  };

  /**
   * Close the ul if the focus is lost
   * @param {*} e
   */
  const handleBlur = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setOpened(false);
    }
  };

  /**
   * When the user selects the option
   * @param {*} option
   */
  const handleOptionClick = (option) => {
    onSelectFn(option.value);
    setOpened(false);
  };

  return (
    <div
      className={`dropdown ${opened ? "open" : ""} `}
      data-align-right={alignRight ? true : undefined}
      onBlur={handleBlur}
      onMouseEnter={(e) => {
        e.preventDefault();
        setOpened(true);
      }}
      onMouseLeave={(e) => {
        e.preventDefault();
        setOpened(false);
      }}
      role="menu"
      tabIndex={0}
      style={isAdminConsole ? { paddingBottom: 8 } : {}}
    >
      <button
        onClick={handleClick}
        aria-haspopup="menu"
        aria-expanded={opened}
        data-button-type="primary"
      >
        <SvgIcon
          src="/img/new-icons/add.svg"
          noFilterOnLight={true}
          alt="add exercise"
          classNames="mobile-hidden"
        />
        <p>{summaryText}</p>
        <SvgIcon
          src={opened ? "/img/svg/angle-up.svg" : "/img/svg/angle-down.svg"}
        />
      </button>

      <ul className={opened ? "opened dropdown-menu" : "dropdown-menu"}>
        {options.map((option, i) => (
          <li key={option.value} role="none">
            <button
              role="menuitem"
              onMouseDown={(e) => {
                e.preventDefault();
                handleOptionClick(option);
              }}
              onTouchEnd={(e) => {
                e.preventDefault();
                handleOptionClick(option);
              }}
            >
              {option.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

PrimaryDropdown.propTypes = {
  summaryText: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.any.isRequired,
    })
  ).isRequired,
  onSelectFn: PropTypes.func.isRequired,
  alignRight: PropTypes.bool,
  isAdminConsole: PropTypes.bool,
};

export default PrimaryDropdown;
